import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";

export function integerValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === "") return null;

    return typeof value === "number" && Number.isInteger(value)
      ? null
      : {integer: true};
  };
}
